import {Image} from 'antd';
import 'aos/dist/aos.css';

import jewelry1 from '../../../assets/AboutUs/1.webp';
import jewelry4 from '../../../assets/AboutUs/2.jpg';
import jewelry2 from '../../../assets/AboutUs/3.jpg';
import texture from '../../../assets/AboutUs/download.jpg';
import jewelry3 from '../../../assets/AboutUs/Gemini_Generated_Image_b2t9mlb2t9mlb2t9.png';
import logo from '../../../assets/Images/Logo.png';

const AboutUs = () => {
  return (
    <div className={'w-full bg-[#faf8f5] text-gray-800 font-body overflow-hidden'}>

      <div className={'w-full'}>
        
        <div className={'grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-14 items-center py-12 sm:py-14 lg:py-18'}>

          <div className={''} data-aos={'fade-right'}>
            <Image
              src={jewelry1}
              preview={false}
              className={'w-full h-[220px] sm:h-[260px] lg:h-[320px] object-contain rounded-lg'}
            />
          </div>

          <div data-aos={'fade-left'}>

            <h2 className={'font-heading text-2xl sm:text-3xl lg:text-4xl mb-2'}>
              Legacy Meets Luxury
            </h2>

            <div className={'luxury-divider'} />

            <p className={'mt-4 leading-relaxed text-gray-600 text-sm sm:text-base'}>
              With nearly three decades of craftsmanship, Ratnaparkhi Jewellers
              represents trust, precision and artistic excellence. Our imitation
              jewellery extends this heritage, bringing luxury aesthetics to
              modern lifestyles.
            </p>

          </div>

        </div>
        
        <div className={'grid lg:grid-cols-2 rounded-xl overflow-hidden'}>

          {/* LEFT SIDE */}
          <div
            className=
              {`flex
      flex-col
      justify-center
      md:px-16 px-8 lg:px-16
      py-12
      text-white
      min-h-[280px] lg:min-h-[400px]`}
    
            style={{
              backgroundColor: '#7a2e22',
              backgroundImage: `url(${texture})`,
              backgroundBlendMode: 'multiply',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              // marginBottom:'2',
            }}
          >

            <Image
              src={logo}
              preview={false}
              width={152}
              className={'mb-6 items-center justify-center flex mx-auto'}
            />

            <h1
              data-aos={'fade-up'}
              className={'font-heading text-3xl sm:text-4xl lg:text-5xl mb-3'}
            >
      An Ode to India
            </h1>

            <div className={'luxury-divider'} />

            <p
              data-aos={'fade-up'}
              data-aos-delay={'200'}
              className={'mt-4 max-w-xl leading-relaxed text-sm sm:text-base opacity-90'}
            >
      A place where traditions and modernity thrive together.
      Our jewels capture stories, emotion and artistry —
      bringing timeless elegance into modern expression.
            </p>

          </div>

          {/* RIGHT SIDE IMAGE */}
          <Image
            src={jewelry2}
            preview={false}
            data-aos={'fade-left'}
            className=
              {` w-full
        h-full
        min-h-[280px] md:rounded-bl-none  overflow-hidden rounded-b-xl md:min-h-[425px]
        object-cover`}
          />
        </div>
       
        {/* Crafted With Precision */}
        <div className={'grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-14 items-center py-12 sm:py-14 lg:py-18'}>
          <div data-aos={'fade-right'}>
            <h2 className={'font-heading text-2xl sm:text-3xl lg:text-4xl mb-2'}>
              Crafted With Precision
            </h2>
            <div className={'luxury-divider'} />
            <p className={'mt-4 leading-relaxed text-gray text-sm sm:text-base'}>
              Inspired by traditional jewellery mastery, every design reflects
              grace, elegance and attention to detail.
              Our collections celebrate individuality and sophistication.
            </p>
          </div>
          <Image
            src={jewelry3}
            preview={false}
            className={'w-full h-[225px] sm:h-[260px] lg:h-[325px] shadow-lg object-cover rounded-lg'}
          />
        </div>
      
        <div className={'py-14 text-center'} data-aos={'fade-up'}>
          <h2 className={'font-heading text-2xl sm:text-3xl lg:text-4xl mb-3'}>
            Business Partnerships
          </h2>
          <div className={'luxury-divider mx-auto'} />
          <p className={'mt-4 max-w-xl mx-auto text-gray-600 leading-relaxed text-sm sm:text-base'}>
            We collaborate with boutiques, retailers and brands offering curated
            collections and bulk jewellery solutions.
          </p>
        </div>

        <div className={'grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-14 items-center py-12 sm:py-14 lg:py-18'}>
          <Image
            src={jewelry4}
            preview={false}
            className={'w-full h-[220px] sm:h-[260px] lg:h-[320px] shadow-lg object-contain rounded-lg'}
          />
          <div data-aos={'fade-left'}>

            <h2 className={'font-heading text-2xl sm:text-3xl lg:text-4xl mb-2'}>
              Our Vision
            </h2>

            <div className={'luxury-divider'} />

            <p className={'mt-4 leading-relaxed text-gray-600 text-sm sm:text-base'}>
              Expanding into silver and gold collections, we continue our
              promise of timeless elegance and refined beauty.
              Jewellery is identity, expression and legacy.
            </p>

          </div>

        </div>

      </div>

      {/* footer tagline */}
      <div className={'text-center py-8 text-gray-500 text-xs sm:text-sm tracking-wide px-4'}>
        Crafted with passion • Designed for elegance • Trusted for generations
      </div>

    </div>
  );
};

export default AboutUs;
